import React, { useContext } from 'react';
import { FilterContext } from 'components/shared/FilterContext/index';
import ActiveUsersModule from './ActiveUsers/ActiveUsersModule';
import OverdueAssignmentsModule from './Overdue/OverdueAssignmentsModule';
import CompletedAssignmentsModule from './CompletedAssignments/CompletedAssignmentsModule';
import LessonViewsModule from './LessonViews/LessonViewsModule';
import SearchModule from './Search/SearchModule';
import { useHasSelectedFilters } from './Filters/HasFilters';

const LearnerEngagementContainer = ({ i18n, permissions }) => {
  const renderOverdueVertical = permissions.completedAssignments;
  const hasSelectedFilters = useHasSelectedFilters();
  const { params: filterParams } = useContext(FilterContext);
  const overdueAssignmentsHidden =
    hasSelectedFilters && !!(filterParams.start_date || filterParams.end_date);

  return (
    <div>
      {permissions.lessonViews && <LessonViewsModule i18n={i18n} />}
      {permissions.searches && <SearchModule i18n={i18n} />}
      {permissions.activeUsers && <ActiveUsersModule i18n={i18n} />}
      <div className="d-f fw-w">
        {permissions.completedAssignments && (
          <CompletedAssignmentsModule i18n={i18n} />
        )}
        {overdueAssignmentsHidden && <div className="f-1" />}
        {permissions.overdueAssignments && !overdueAssignmentsHidden && (
          <OverdueAssignmentsModule
            i18n={i18n}
            vertical={renderOverdueVertical}
          />
        )}
      </div>
    </div>
  );
};

export default LearnerEngagementContainer;
